import { defineStore } from 'pinia'
import { INewOrder } from "@/interface"
import { ContextOrderEnum } from "@/enums"

export const useNewOrderStore = defineStore({
    id: 'newOrder',
    state: () => ({
        newOrder: {} as INewOrder,
        oldOrder: {} as INewOrder,
        historyContract: {} as INewOrder,
        orderPendingId: null as null | string,
        isPending: false,
        context: ContextOrderEnum.EditNewOrder
    }),
    getters: {
        order: (state): INewOrder => state.newOrder,
        EditHistoryContract: (state) => state.historyContract,
        contextEdit: (state) => state.context,
        isPendingProduct: (state) => state.isPending,
        getOrderPendingId: (state) => state.orderPendingId
    },
    persist: true,
    actions: {
        setNewOrder(order: INewOrder){
            this.newOrder = order;
        },
        setEditHistoryContract(order: { new: INewOrder, old: INewOrder }) {
            if (!order) {
                return;
            }
            this.oldOrder = order.old;
            this.newOrder = order.new;
            this.historyContract = order.new;
        },
        setContextEdit(context: ContextOrderEnum) {
            this.context = context;
        },
        setIsPendingProduct(pending: string | null){
            this.isPending = !!pending;
            this.orderPendingId = pending;
        },
        setOrderPendingId(orderPendingId: string){
            this.orderPendingId = orderPendingId;
        },
        resetNewOrder() {
            this.newOrder = {} as INewOrder;
        }
    }
})

export type NewOrderStore = ReturnType<typeof useNewOrderStore>